import 'css-chunksrc/client/pages/projectPage/synthesisPage/reports/loader/report/indicatorsList/styles.scss';export default {
  "indicatorsList": "_indicatorsList_7w6g6_1",
  "input": "_input_7w6g6_7",
  "indicatorSkeleton": "_indicatorSkeleton_7w6g6_14",
  "nameSkeleton": "_nameSkeleton_7w6g6_20"
};